
document.addEventListener("DOMContentLoaded", () => {
  const items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      // Use a delay to check if the mouse is still in the menu
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200); // 200ms delay
    });

    item.querySelector("ul").addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200); // 200ms delay
    });
  });
});

// $('.product-sticky-bar__info .ct-atc_btn').click(function(){
//     $(this).parents('.ct-MainProduct-template-main').find('.ct-main-button .product-form__buttons').trigger('click');
// })
$(document).on('click', '.product-sticky-bar__info .ct-atc-btn', function() {
  console.log('clicked by ketan');
  $(this).parents('.ct-main-product_section').find('.ct-main-button .product-form__submit').trigger('click');
});





$(document).ready(function() {
    function updateVariantName($gridItem) {
        // Find the checked input in this grid item
        var $checkedInput = $gridItem.find('.color-selector input[type="radio"]:checked');
        
        if ($checkedInput.length) {
            // Find the span just below the input (assumed to be sibling or close descendant)
            var colorName = $checkedInput.next('span').text().trim();

            // Update the .ct_varient_name text
            $gridItem.find('.ct_varient_name').text(colorName);
        }
    }

    // Initial update on page load for all .grid__item
    $('.grid__item').each(function() {
        updateVariantName($(this));
    });

    // On change of any radio input, update only the respective .grid__item
    $('.grid__item .color-selector input[type="radio"]').on('change', function() {
        var $gridItem = $(this).closest('.grid__item');
        updateVariantName($gridItem);
    });
});






// thumbnail slider script start

$(document).ready(function () {
  let checkedVariant = $('.ct_color_box input[type="radio"]:checked').val();
 // console.log('checkedVariant:', checkedVariant);
  $('.thumbnail-list__item').each(function () {
      let firstvariant_img = $(this).data('color');
      if (checkedVariant == firstvariant_img) {
        $(this).addClass('var_color_true');
      } else {
        $(this).addClass('var_color_false');
      }
    });
  $(document).on('change', '.ct_color_box input[type="radio"]', function () {
    let selectedVariantId = $(this).val();
    // console.log("Variant changed:", selectedVariantId);

    let $thumbnailItems = $(this).closest('.product--thumbnail_slider').find('.thumbnail-list__item');

    $thumbnailItems.each(function () {
      let variant_img = $(this).data('color');
      if (selectedVariantId == variant_img) {
        // console.log('true', variant_img);
        // $('.thumbnail-list__item').removeClass('var_color_false');
        $(this).removeClass('var_color_false');
        $(this).addClass('var_color_true');
      } else {
        // console.log('color not find', variant_img);
        $(this).addClass('var_color_false');
      }
    });
  });
});







$(document).ready(function () {
  let checkedVariant = $('.ct_color_box input[type="radio"]:checked').val();
 console.log('checkedVariant kk:', checkedVariant);
  $('.ct-product__media-item').each(function () {
      let firstvariant_img = $(this).attr('thumbnail-alt');
      if (checkedVariant == firstvariant_img) {
        $(this).addClass('ct-var_color_true');
      } else {
        $(this).addClass('ct-var_color_false');
      }
    });
  $(document).on('change', '.ct_color_box input[type="radio"]', function () {
    let selectedVariantId = $(this).val();
    // console.log("Variant changed:", selectedVariantId);

    let $main_mediaItems = $(this).parents('.ct-main-product_section').find('.ct-main-product-media .ct-product__media-item');

    $main_mediaItems.each(function () {
      let variant_img = $(this).attr('thumbnail-alt');
      if (selectedVariantId == variant_img) {
        console.log('true kk', variant_img);
        // $('.thumbnail-list__item').removeClass('var_color_false');
        $(this).removeClass('ct-var_color_false');
        $(this).addClass('ct-var_color_true');
      } else {
        console.log('color not find kk', variant_img);
        $(this).addClass('ct-var_color_false');
      }
    });
  });
});


// thumbnail slider script End